module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.woff?40f483d6f7ef034dee114865ce30a6e3";